





















import { Component, Vue } from 'vue-property-decorator';
import { CustomField, CustomFieldData } from '@/models/Contact';
import DynamicForm from '@/components/Form/DynamicForm.vue';
import http from '@/services/Http';

// Assuming you import websiteText via a mixin or helper as you did in V3
import { websiteText } from '@/mixins/websiteTexts'; 

declare var grecaptcha: any;

@Component({
    components: {
        DynamicForm
    }
})
export default class ContactForm extends Vue {
    showForm: boolean = true;
    isSubmitting: boolean = false;
    errorMsgs: string[] = [];
    
    title: string = '';
    text: string = '';
    selectedOrgName: string = '';
    dataLayer = (window as any).dataLayer || [];

    // Helper for template translation
    websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    constructor() {
        super();
        this.selectedOrgName = this.$attrs['data-retailer-name'];
        this.title = this.$attrs['data-title'];
        this.text = JSON.parse(this.$attrs['data-text']);
    }

    get formSchema(): CustomField[] {
        return [
            { placeholder: this.websiteText('retailer.name'), fieldType: 'TextField', mandatory: false, tabIndex: 1 },
            { placeholder: this.websiteText('retailer.email'), fieldType: 'EmailField', mandatory: true, tabIndex: 2 },
            { placeholder: this.websiteText('retailer.telephone'), fieldType: 'TextField', mandatory: false, tabIndex: 3 },
            { placeholder: this.websiteText('retailer.city'), fieldType: 'TextField', mandatory: false, tabIndex: 4 },
            { placeholder: this.websiteText('retailer.message'), fieldType: 'MultirowTextField', mandatory: false, tabIndex: 5 },
            { 
                placeholder: '', 
                fieldType: 'CheckboxField', 
                options: [{ text: this.websiteText('retailer.subscribetonewsletter'), value: 'true' }], 
                mandatory: false, 
                tabIndex: 6 
            }
        ];
    }

    handleFormSubmit(formData: CustomFieldData[]) {
        this.errorMsgs = [];
        this.isSubmitting = true;
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        grecaptcha.ready(() => {
            grecaptcha
                .execute(recaptchaSiteKey, { action: 'submit' })
                .then((token: string) => {
                    this.executeApiCall(token, formData);
                })
                .catch(() => {
                    this.isSubmitting = false;
                    this.errorMsgs.push('ReCAPTCHA failed. Please try again.');
                });
        });
    }

    private executeApiCall(token: string, formData: CustomFieldData[]) {
        const mappedPayload = {
            name: formData[0].value,
            email: formData[1].value,
            phone: formData[2].value,
            city: formData[3].value,
            message: formData[4].value,
            newsletter: formData[5].value === 'true',
            token: token
        };
        
        http.post(`/api/contactform`, mappedPayload)
            .then(() => {
                this.showForm = false;
                
                this.dataLayer.push({
                    event: 'reseller-form',
                    'reseller-formtype': 'contact',
                    email: mappedPayload.email,
                    store: this.selectedOrgName,
                    name: mappedPayload.name,
                    phoneNumber: mappedPayload.phone,
                    city: mappedPayload.city,
                    message: mappedPayload.message
                });
            })
            .catch((err: string) => {
                console.error('Error sending contact form:', err);
                this.errorMsgs.push(this.websiteText('site.contactform.error_generic') || 'An error occurred. Please try again.');
            })
            .finally(() => {
                this.isSubmitting = false;
            });
    }
}
